export default __webpack_public_path__ + "static/media/endorsement-perpani-kebumen.7f8edd41.png";